import { useState, useEffect } from "react";
import { Tag } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface NicknameDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialValue?: string | null;
  onSave: (nickname: string) => void;
}

export function NicknameDialog({ open, onOpenChange, initialValue, onSave }: NicknameDialogProps) {
  const [value, setValue] = useState(initialValue ?? "");

  useEffect(() => {
    if (open) setValue(initialValue ?? "");
  }, [open, initialValue]);

  const handleSave = () => {
    onSave(value.trim());
    onOpenChange(false);
  };

  const handleClear = () => {
    onSave("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Tag className="h-5 w-5 text-primary" />
            Apelido do cliente
          </DialogTitle>
          <p className="text-sm text-muted-foreground">
            Nome para chamar o cliente quando o pedido ficar pronto. Sai na impressão de produção.
          </p>
        </DialogHeader>

        <Input
          autoFocus
          maxLength={60}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Ex.: João, Mesa do aniversário, Boné azul..."
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSave();
            }
          }}
        />

        <DialogFooter className="gap-2">
          {initialValue ? (
            <Button variant="ghost" onClick={handleClear}>
              Limpar
            </Button>
          ) : null}
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={handleSave}>Salvar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}